@if (includeSearch) {
  <mat-form-field class="search-bar">
    <mat-label>Search</mat-label>
    <input matInput id="search-input" (keyup)="applyFilter($event.target.value)">
    <mat-hint>Name, Organization, I-Number or Birthdate (mm/dd/yyyy)</mat-hint>
  </mat-form-field>
}
<table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef='organization'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
    <td mat-cell *matCellDef='let element'>{{element.organization}}</td>
  </ng-container>
  <ng-container matColumnDef='guestName'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
    <td mat-cell *matCellDef='let element'>
      <a [routerLink]="['/sponsor/manage', element.guestRoleId]">{{element.guestName}}</a>
    </td>
  </ng-container>
  <ng-container matColumnDef='roleName'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
    <td mat-cell *matCellDef='let element'>{{element.roleName}}</td>
  </ng-container>
  <ng-container matColumnDef='createdOn'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Created on</th>
    <td mat-cell *matCellDef='let element'>{{element.createdOn | date}}</td>
  </ng-container>
  <ng-container matColumnDef='startDate'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
    <td mat-cell *matCellDef='let element'>{{element.startDate | date}}</td>
  </ng-container>
  <ng-container matColumnDef='endDate'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
    <td mat-cell *matCellDef='let element'>{{element.endDate | date}}</td>
  </ng-container>
  <ng-container matColumnDef='active'>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
    <td mat-cell *matCellDef='let element'>{{element.active ? '✔' : ''}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef='displayedColumns'></tr>
  <tr mat-row *matRowDef='let row; columns: displayedColumns;' class="guest-row"></tr>
</table>

<mat-paginator [pageSizeOptions]="[25, 50, 100]"></mat-paginator>